import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ertigaonrentinpune() {



    const cardData = {

keyword: "Ertiga On Rent in Pune",

headingDescription:
    "Rising Cab Service offers safe, affordable, and comfortable Ertiga On Rent in Pune for family trips, airport transfers, corporate travel, weekend getaways, and outstation journeys. Our well-maintained Maruti Suzuki Ertiga cars come with spacious 7-seater seating, powerful AC, clean interiors, smooth suspension, and experienced chauffeurs for a hassle-free travel experience. With doorstep pickup across Pune, flexible rental options, 24/7 availability, one-way and round-trip services, and transparent pricing, we ensure a reliable and comfortable journey for small families and groups.",

topPlaces: [
    {
        title: "Lonavala & Khandala Weekend Trip",
        description:
            "Lonavala and Khandala are the most popular hill stations near Pune, known for green valleys, waterfalls, misty mountains, and scenic viewpoints. Ertiga is perfect for small families and groups looking for a comfortable, budget-friendly, and private weekend getaway with smooth highway travel and scenic monsoon drives."
    },
    {
        title: "Mahabaleshwar & Panchgani Tour",
        description:
            "Mahabaleshwar and Panchgani are famous hill stations known for strawberry farms, lakes, viewpoints, and cool climate. Ertiga provides a comfortable travel option for families exploring nature, sightseeing spots, and relaxing hill station environments from Pune."
    },
    {
        title: "Shirdi Sai Baba Darshan",
        description:
            "Shirdi is one of the most important pilgrimage destinations in Maharashtra dedicated to Sai Baba. Ertiga on rent is widely used for family darshan trips, ensuring a smooth and peaceful journey with comfort and convenience for devotees traveling from Pune."
    },
    {
        title: "Nashik & Trimbakeshwar Jyotirlinga",
        description:
            "Nashik is a spiritual and cultural city known for Trimbakeshwar Jyotirlinga, Panchavati temples, and vineyards. Ertiga is ideal for small groups combining pilgrimage and leisure travel with comfortable seating and economical travel from Pune."
    },
    {
        title: "Pune Airport Transfers",
        description:
            "Ertiga is one of the most preferred vehicles for Pune airport pickup and drop services due to its spacious seating, luggage capacity, and comfort. It ensures timely and hassle-free transfers for families and business travelers."
    },
    {
        title: "Alibaug Beach Trip",
        description:
            "Alibaug is a coastal destination near Mumbai known for beaches, forts, and water sports. Ertiga is perfect for family beach vacations and weekend trips from Pune, offering comfort and privacy throughout the journey."
    },
    {
        title: "Bhimashankar Jyotirlinga Visit",
        description:
            "Bhimashankar is a sacred Jyotirlinga temple located in the Sahyadri hills surrounded by forests. Ertiga provides a safe and comfortable travel option for devotees and nature lovers traveling from Pune for spiritual darshan."
    },
    {
        title: "Ashtavinayak Darshan Circuit",
        description:
            "The Ashtavinayak pilgrimage includes eight sacred Ganpati temples across Maharashtra. Ertiga is ideal for small family spiritual tours, offering comfortable seating and flexible travel arrangements from Pune."
    },
    {
        title: "Lavasa Hill City Trip",
        description:
            "Lavasa is a scenic planned hill city near Pune known for lakeside views and architecture. Ertiga is perfect for short family trips and leisure drives with comfortable and relaxed travel experience."
    },
    {
        title: "Outstation Budget Travel",
        description:
            "Ertiga is a popular choice for outstation travel from Pune due to its fuel efficiency, comfort, and affordability. It is suitable for short and medium-distance family trips across Maharashtra."
    }
],



services: [
{
name: "Ertiga on Rent in Pune",
description: "Rising Cab Service offers Ertiga on Rent in Pune for comfortable, spacious, and budget-friendly travel for families, groups, and corporate passengers. Our Maruti Suzuki Ertiga fleet is well-maintained, fuel-efficient, and ideal for both city rides and long outstation journeys. We provide professional chauffeurs, doorstep pickup, 24x7 availability, and transparent pricing with no hidden charges. Whether you need airport transfer, local travel, or outstation trips, Ertiga ensures smooth driving, AC comfort, and reliable travel experience across Pune and nearby destinations."
},
{
name: "Ertiga Car on Rent in Pune",
description: "Book Ertiga Car on Rent in Pune with Rising Cab Service for safe and comfortable group travel. The Ertiga is perfect for family trips, business travel, and airport transfers, offering spacious seating, AC comfort, and smooth suspension for long-distance journeys. Our service ensures punctual pickup, experienced drivers, and affordable pricing for all travel needs."
},
{
name: "Ertiga CNG on Rent in Pune",
description: "Rising Cab Service provides Ertiga CNG on Rent in Pune for economical and eco-friendly travel. Ideal for daily commuting and budget-conscious travelers, our CNG Ertiga cabs offer low running cost, clean interiors, and comfortable seating with professional drivers ensuring safe city and outstation travel."
},
{
name: "Ertiga Rent in Pune",
description: "Book Ertiga Rent in Pune for flexible travel solutions including hourly, daily, and outstation packages. Our service includes well-maintained vehicles, experienced chauffeurs, and 24x7 booking support, making it suitable for family trips, corporate travel, and airport transfers."
},
{
name: "Ertiga Rent Per Km in Pune",
description: "Rising Cab Service offers transparent Ertiga Rent Per Km in Pune for both local and outstation travel. Our pricing is affordable and clearly structured, ensuring customers only pay for the distance traveled with no hidden charges, making it cost-effective for long journeys."
},
{
name: "Maruti Ertiga on Rent in Pune",
description: "Book Maruti Ertiga on Rent in Pune for reliable and comfortable transportation. The vehicle is ideal for small groups and families, offering AC comfort, spacious interiors, and smooth highway performance with professional chauffeur service."
},
{
name: "Maruti Suzuki Ertiga Rental Pune",
description: "Rising Cab Service provides Maruti Suzuki Ertiga Rental in Pune for safe and budget-friendly travel. Our well-maintained vehicles ensure smooth rides for city travel, airport transfers, and outstation trips with experienced drivers."
},
{
name: "Ertiga Taxi Service Pune",
description: "Book Ertiga Taxi Service in Pune for comfortable and reliable group travel. Our service includes clean AC vehicles, punctual pickups, and professional chauffeurs for both local and long-distance journeys."
},
{
name: "Ertiga Car Booking Pune",
description: "Rising Cab Service offers Ertiga Car Booking in Pune for instant and hassle-free reservations. Customers can easily book online or via call for city rides, airport transfers, and outstation travel with quick confirmation."
},
{
name: "Ertiga Outstation Taxi Pune",
description: "Book Ertiga Outstation Taxi in Pune for safe and comfortable long-distance travel. Our service covers popular routes like Mumbai, Goa, Shirdi, Nashik, and Mahabaleshwar with experienced drivers and affordable pricing."
},
{
name: "Ertiga Cab for Family Trip Pune",
description: "Rising Cab Service provides Ertiga Cab for Family Trip in Pune for spacious and comfortable travel. Ideal for vacations and weekend getaways, our vehicles ensure smooth rides with AC comfort and professional drivers."
},
{
name: "Ertiga Airport Transfer Pune",
description: "Book Ertiga Airport Transfer in Pune for timely and reliable pickup and drop services. Our chauffeurs ensure punctual arrivals, luggage assistance, and comfortable travel to and from Pune Airport."
},
{
name: "Pune Ertiga Car Hire",
description: "Rising Cab Service offers Pune Ertiga Car Hire for flexible travel options including hourly, daily, and outstation packages. Enjoy clean vehicles, professional drivers, and affordable rates for all travel needs."
},
{
name: "7 Seater Ertiga on Rent Pune",
description: "Book 7 Seater Ertiga on Rent in Pune for comfortable group travel. The vehicle offers spacious seating, AC comfort, and smooth driving experience, making it ideal for family and business trips."
},
{
name: "Ertiga Tourist Vehicle Pune",
description: "Rising Cab Service provides Ertiga Tourist Vehicle in Pune for sightseeing and travel packages. Our vehicles are perfect for local tours, hill stations, and outstation trips with experienced chauffeurs."
},
{
name: "Ertiga Cab Booking Online Pune",
description: "Book Ertiga Cab Booking Online in Pune for quick and convenient reservations. Our online system ensures instant confirmation, transparent pricing, and 24x7 customer support for hassle-free travel."
},
{
name: "Ertiga On Rent in Hinjewadi Pune",
description: "Rising Cab Service offers Ertiga On Rent in Hinjewadi Pune for corporate and local travel. Ideal for IT professionals and office commuting with reliable drivers and timely service."
},
{
name: "Ertiga On Rent in Kharadi Pune",
description: "Book Ertiga On Rent in Kharadi Pune for comfortable and affordable transportation. Our service is perfect for corporate employees, families, and airport transfers with smooth travel experience."
},
{
name: "Ertiga On Rent in Hadapsar Pune",
description: "Rising Cab Service provides Ertiga On Rent in Hadapsar Pune for city and outstation travel. Enjoy clean vehicles, professional chauffeurs, and reliable service for all travel needs."
},
{
name: "Ertiga On Rent in Baner Pune",
description: "Book Ertiga On Rent in Baner Pune for quick and convenient travel solutions. Ideal for families and corporate users with comfortable seating and punctual service."
},
{
name: "Ertiga On Rent in Wakad Pune",
description: "Rising Cab Service offers Ertiga On Rent in Wakad Pune for local and outstation travel. Enjoy affordable pricing, clean vehicles, and experienced drivers for safe journeys."
},
{
name: "Ertiga On Rent in Pimpri Chinchwad",
description: "Book Ertiga On Rent in Pimpri Chinchwad for reliable transportation across PCMC and Pune. Our service ensures comfort, safety, and affordability for all travel requirements."
},
{
name: "Ertiga On Rent in Viman Nagar Pune",
description: "Rising Cab Service provides Ertiga On Rent in Viman Nagar Pune for airport transfers and city travel. Our vehicles ensure timely service and comfortable rides for passengers."
},
{
name: "Ertiga On Rent in Kothrud Pune",
description: "Book Ertiga On Rent in Kothrud Pune for family trips, corporate travel, and outstation journeys with professional drivers and clean AC vehicles."
},
{
name: "Ertiga On Rent in Magarpatta Pune",
description: "Rising Cab Service offers Ertiga On Rent in Magarpatta Pune for IT professionals and corporate travel needs with reliable and timely service."
},
{
name: "Ertiga On Rent in Wagholi Pune",
description: "Book Ertiga On Rent in Wagholi Pune for convenient city and airport travel with affordable pricing and experienced chauffeurs."
},
{
name: "Ertiga On Rent in Pune",
description: "Rising Cab Service provides Ertiga On Rent in Pune for all types of travel including city rides, airport transfers, and outstation trips with comfort and reliability."
}
],

tableData: [
["Ertiga on Rent in Pune","Ertiga Car on Rent in Pune"],
["Ertiga CNG on Rent in Pune","Ertiga Rent in Pune"],
["Ertiga Rent Per Km in Pune","Maruti Ertiga on Rent in Pune"],
["Maruti Suzuki Ertiga Rental Pune","Ertiga Taxi Service Pune"],
["Ertiga Outstation Taxi Pune","Ertiga Cab for Family Trip Pune"],
["Ertiga Airport Transfer Pune","7 Seater Ertiga on Rent Pune"],
["Ertiga On Rent in Hinjewadi Pune","Ertiga On Rent in Kharadi Pune"],
["Ertiga On Rent in Hadapsar Pune","Ertiga On Rent in Baner Pune"],
["Ertiga On Rent in Wakad Pune","Ertiga On Rent in Pimpri Chinchwad"]
],




whychoose: [
    {
        WhyChooseheading: "Affordable Ertiga on Rent in Pune",
        WhyChoosedescription: "Rising Cab Service provides comfortable Ertiga rental services in Pune for family trips, airport transfers, outstation travel, corporate transportation, and sightseeing tours."
    },
    {
        WhyChooseheading: "Perfect 7 Seater for Family Travel",
        WhyChoosedescription: "Maruti Suzuki Ertiga is one of the most preferred family vehicles offering spacious seating, smooth performance, and excellent comfort for long-distance journeys."
    },
    {
        WhyChooseheading: "Suitable for Local and Outstation Trips",
        WhyChoosedescription: "Book Ertiga for Pune city travel and popular destinations including Mumbai, Shirdi, Mahabaleshwar, Goa, Nashik, Kolhapur, Lonavala, and Konkan tours."
    },
    {
        WhyChooseheading: "Comfortable Seating with Large Luggage Space",
        WhyChoosedescription: "The vehicle offers ample space for passengers and luggage, making it ideal for family vacations, airport travel, and weekend getaways."
    },
    {
        WhyChooseheading: "Ideal for Airport and Corporate Travel",
        WhyChoosedescription: "Ertiga is widely used for Pune Airport transfers, Mumbai Airport travel, corporate meetings, business tours, and executive transportation."
    },
    {
        WhyChooseheading: "Pickup Service Across Pune and PCMC",
        WhyChoosedescription: "Doorstep pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, Wagholi, and nearby locations."
    },
    {
        WhyChooseheading: "Professional Drivers and Well-Maintained Vehicles",
        WhyChoosedescription: "Our experienced drivers and regularly serviced Ertiga vehicles ensure safe travel, punctual service, and a comfortable journey."
    },
    {
        WhyChooseheading: "Best Choice for Tours and Pilgrimage Travel",
        WhyChoosedescription: "Ertiga rentals are perfect for Shirdi trips, Ashtavinayak tours, Jyotirlinga Darshan, family holidays, wedding travel, and sightseeing journeys."
    }
]
};

const faqData = [
    {
        question: "Why is Ertiga a popular rental vehicle in Pune?",
        answer: "Ertiga offers spacious seating for seven passengers, excellent comfort, good luggage space, and smooth performance for local and outstation travel."
    },
    {
        question: "Can I hire an Ertiga for outstation trips?",
        answer: "Yes, Ertiga vehicles are available for outstation destinations across Maharashtra and neighboring states."
    },
    {
        question: "Is Ertiga suitable for family vacations?",
        answer: "Yes, Ertiga is one of the best options for family holidays because of its spacious seating and comfortable travel experience."
    },
    {
        question: "Do you provide Ertiga for airport transfers?",
        answer: "Yes, Ertiga rentals are available for Pune Airport and Mumbai Airport pickup and drop services."
    },
    {
        question: "Can I book an Ertiga for one-way travel?",
        answer: "Yes, both one-way and round-trip Ertiga bookings are available."
    },
    {
        question: "Is the vehicle air-conditioned?",
        answer: "Yes, all Ertiga rental vehicles are equipped with air conditioning for passenger comfort."
    },
    {
        question: "Can corporate clients hire Ertiga vehicles?",
        answer: "Yes, Ertiga is commonly used for executive travel, client visits, employee transportation, and business trips."
    },
    {
        question: "Do you provide Ertiga for pilgrimage tours?",
        answer: "Yes, Ertiga vehicles are available for Shirdi, Pandharpur, Tuljapur, Akkalkot, Ashtavinayak, and Jyotirlinga tour packages."
    },
    {
        question: "Can I book Ertiga for wedding and family events?",
        answer: "Yes, Ertiga is frequently hired for wedding transportation, family functions, and special occasions."
    },
    {
        question: "How can I book an Ertiga on Rent in Pune?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Nikhil More",
        feedback:
            "We booked an Ertiga for our Shirdi family trip. The vehicle was spacious, comfortable, and the journey was smooth from start to finish.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Vaishali Patwardhan",
        feedback:
            "Our airport transfer and weekend vacation were perfectly managed with the Ertiga. The car was clean, comfortable, and ideal for family travel.",
        rating: 5
    }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];









const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Ertiga on Rent in Pune",
"image": "https://www.risingcabservice.com/assets/images/ertiga-on-rent-pune.jpg",
"description": "Book Maruti Ertiga on Rent in Pune with Rising Cab Service for comfortable 7-seater family travel, airport transfers, and outstation trips. Ideal for affordable AC cab service with professional drivers.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹13/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/ertiga-on-rent-in-pune"
}
};







    return (
        <div>
<Helmet>
  <title>Ertiga on Rent in Pune | 7 Seater Family Cab | +91 9272511548</title>

<meta
 name="description"
 content="Book Maruti Ertiga on Rent in Pune for family trips, airport transfers, and outstation travel. Get affordable 7-seater AC cab with driver for safe journeys."
/>

<meta
 name="keywords"
 content="ertiga on rent pune, ertiga car on rent in pune, ertiga cng on rent in pune, ertiga rental pune, maruti ertiga on rent in pune, ertiga taxi service pune, ertiga cab booking pune, 7 seater ertiga pune, ertiga airport transfer pune, ertiga outstation taxi pune, ertiga hire hinjewadi pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>





            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/86.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Ertigaonrentinpune;